import { connect } from 'react-redux';
import {
  assignConversationToSpecialist,
  reassignConversationToSpecialist,
  hideConversation,
  unhideConversation,
  clearHistoricalTicket,
  setBtnActivity,
  setTaggingActive,
  setShowTools as showToolsAction,
  setChatMacroRecommendationsEnabled,
} from '../actions/index';
import { setMacroWizardPath } from '../actions/searchActions';
import AllTicketComponent from '../components/AllTicketComponent/AllTicketComponent';
import {
  extractSelectedTicketBusinessDetailsFromState,
  extractSelectedHistoricalTicketIdFromState,
  extractSelectedTicketIdFromState,
  hasSelectedExpertForForwarding,
  extractSelectedTicketFromState,
  isSpecialistLite,
  getSimplrAccountIdOfSelectedTicket,
  getSimplrTaggingActive,
} from '../extractFromState';
import { getLastPageUrl } from './../util/util';
import { isSimplrCategoryTaggingActiveForSelectedTicket } from '../extractFromState';
import { TICKET_ACTION_SOURCES } from '../analytics/ticketEventAnalytics';
import { trackTakeButtonClick } from '../analytics/buttonEventAnalytics';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
  let selectedTicket = {
    ticket: extractSelectedTicketFromState(state),
    selectedInboxTab: state.ui.messages.selectedInboxTab,
  };

  return {
    btnActivity: state.ui.buttons.btnActivity,
    selectedTicket: selectedTicket,
    selectedConversation: state.conversation,
    simplrAccountId: getSimplrAccountIdOfSelectedTicket(state),
    selectedTicketId: extractSelectedTicketIdFromState(state),
    lastPageUrl: getLastPageUrl(selectedTicket),
    showTools: state.ui.tools.general.showTools,
    businessDetailsForTicket: extractSelectedTicketBusinessDetailsFromState(state),
    isHistoricalTicket: !!extractSelectedHistoricalTicketIdFromState(state),
    hasExpertSelectedInForwarding: hasSelectedExpertForForwarding(state),
    simplrTaggingRequired: isSimplrCategoryTaggingActiveForSelectedTicket(state),
    simplrTaggingActive: getSimplrTaggingActive(state),
    isSpecialistLite: isSpecialistLite(state),
    isAdmin: state.user.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      {
        showToolsAction,
        setTaggingActive,
        clearHistoricalTicket,
        setChatMacroRecommendationsEnabled,
        setMacroWizardPath,
        setBtnActivity,
        onUnhideClick: unhideConversation,
        onHideClick: hideConversation,
      },
      dispatch
    ),
    onTakeClick(conversationId, buttonId) {
      trackTakeButtonClick();
      dispatch(
        assignConversationToSpecialist(conversationId, 'all', buttonId, TICKET_ACTION_SOURCES.ALL_TICKET_COMPONENT)
      );
    },
    onRessaignTicket(conversationId, buttonId) {
      dispatch(
        reassignConversationToSpecialist(conversationId, 'all', buttonId, TICKET_ACTION_SOURCES.ALL_TICKET_COMPONENT)
      );
    },
  };
};

const AllTicketContainer = connect(mapStateToProps, mapDispatchToProps)(AllTicketComponent);

export default AllTicketContainer;
